var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "priority"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 17C6.25 17 5.1875 16.5625 4.3125 15.6875C3.4375 14.8125 3 13.75 3 12.5V7.5C3 6.25 3.4375 5.1875 4.3125 4.3125C5.1875 3.4375 6.25 3 7.5 3H12.5C13.75 3 14.8125 3.4375 15.6875 4.3125C16.5625 5.1875 17 6.25 17 7.5V12.5C17 13.75 16.5625 14.8125 15.6875 15.6875C14.8125 16.5625 13.75 17 12.5 17H7.5ZM8.9375 12.6458L13.1875 8.41667L12.125 7.35417L8.9375 10.5208L7.52083 9.125L6.47917 10.1875L8.9375 12.6458ZM7.5 15.5H12.5C13.3333 15.5 14.0417 15.2083 14.625 14.625C15.2083 14.0417 15.5 13.3333 15.5 12.5V7.5C15.5 6.66667 15.2083 5.95833 14.625 5.375C14.0417 4.79167 13.3333 4.5 12.5 4.5H7.5C6.66667 4.5 5.95833 4.79167 5.375 5.375C4.79167 5.95833 4.5 6.66667 4.5 7.5V12.5C4.5 13.3333 4.79167 14.0417 5.375 14.625C5.95833 15.2083 6.66667 15.5 7.5 15.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriority);
export default __webpack_public_path__ + "static/media/priority.3c1093b34a183a001dca70b591412d80.svg";
export { ForwardRef as ReactComponent };